import { DeviceSelectionDisclaimerCoCo } from './DeviceSelectionDisclaimerCoCo.js';
import { DeviceSelectionListCoCo } from './DeviceSelectionListCoCo.js';
import { DeviceSelectionToolbarCoCo } from './DeviceSelectionToolbarCoCo.js';
import type { DeviceSelectionListCoCoProps } from './DeviceSelectionListCoCo.js';

export const DeviceSelectionCoCo = ({ deviceSelections }: DeviceSelectionListCoCoProps) => (
  <div className="of-device-selection-tab-coco" data-testid="device-selection-tab-coco">
    <DeviceSelectionDisclaimerCoCo />
    <DeviceSelectionToolbarCoCo />
    <DeviceSelectionListCoCo deviceSelections={deviceSelections} />
  </div>
);
